import { useQuery } from '@tanstack/react-query'

import { ClientInvoicesByPeriodService } from '../services/client_invoices_by_period.service'
import { ClientOrderSearchService } from '../services/client_order_search.service'
import { getServiceOptions, mapInvoiceToCustomInvoices, mapOrderToCustomInvoices } from '../mappers'
import { InvoiceClientDto, OrderClientDto } from '../types/api'
import { TBookingInvoiceSearchOptions, TCustomInvoiceDto } from '../types/general'
import { defaultQueryOptions } from './common'

export const useClientBookingInvoices = (locationName: string, options: TBookingInvoiceSearchOptions) => {
  // Choose service dynamically based on sortColumn
  const service = options.sortColumn === 'serviceDates' ? ClientInvoicesByPeriodService : ClientOrderSearchService
  return useQuery<{ results: TCustomInvoiceDto[]; nextToken: string | null }>({
    queryKey: ['clientBookingInvoices', locationName, options, options.sortColumn],
    queryFn: async () => {
      const raw = await service.getData(locationName, getServiceOptions(options))

      // Normalize response to TCustomInvoiceDto[]
      const results =
        options.sortColumn === 'serviceDates'
          ? (raw.results as InvoiceClientDto[]).flatMap(mapInvoiceToCustomInvoices)
          : mapOrderToCustomInvoices(raw.results as OrderClientDto[])

      return {
        results,
        nextToken: raw.nextToken ?? null,
      }
    },
    ...defaultQueryOptions,
  })
}
